import React, { useContext, useState } from 'react'
import InputRegister from "../../blocks/ui/InputDesign";
import { IoMdAdd } from "react-icons/io";
import { GoOrganization } from "react-icons/go";
import placeholder from '../../../assets/Image Placeholder.jpg'
import { gstNumberValidator, organisationValidate } from '../../../utils/validator';
import AccountCreate from './AccountCreate';
import { fetchCreate } from '../../services/SuperAdmin/organisationCreate';
import { DContext } from '../../../context/Datacontext';
import { fromJSON } from 'postcss';
import { compressImage } from '../../../utils/compressImages';
import FloatingLoading from '../../blocks/Layout/Loading';

export default function Organisation() {

    const { BeURL, showAlert, currentUser } = useContext(DContext)

    const types = ['Sole Proprietorship', 'Partnership Firm', 'Limited Liability Partnership (LLP)', 'Private Limited Company (Pvt Ltd)',
        'Public Limited Company (Ltd / PLC)', 'One Person Company (OPC)', 'Others']

    const size = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1001+']

    const [organisation, setOrganisation] = useState({
        companyName: '',
        companyWebsite: '',
        panNumber: '',
        industry: '',
        companyType: '',
        companySize: '',
        gstNumber: '',
        headQuaters: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: ''
        },
        branches: [''],
        description: '',
    })

    const [users, setUsers] = useState({
        firstName: '',
        lastName: '',
        fullName: '',
        email: '',
        alternateEmail: '',
        contact: '',
        alternateContact: '',
        companyId: '',
        role: '',
        password: '',
        confirmPwd: ''
    })

    // Handle the inputs
    const handleOrganisation = (name, value, idx = null) => {
        // update organisation state
        if (["zipCode", "country", "state", "city", "addressLine2", "addressLine1"].includes(name)) {
            setOrganisation((prev) => ({
                ...prev,
                headQuaters: {
                    ...prev.headQuaters,
                    [name]: value,
                },
            }));
        } else if (name === "branches" && idx !== null) {
            // update specific branch
            setOrganisation((prev) => {
                const updatedBranches = [...prev.branches];
                updatedBranches[idx] = value;
                return { ...prev, branches: updatedBranches };
            });

            // validate single branch
            const errorMsg = organisationValidate(name, value);
            setErrors((prev) => ({
                ...prev,
                organisation: {
                    ...prev.organisation,
                    branches: {
                        ...prev.organisation?.branches,
                        [idx]: errorMsg,
                    },
                },
            }));
        } else {
            setOrganisation((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        let errorMsg
        // validate and set error
        if (name === 'gstNumber') {
            errorMsg = gstNumberValidator(value)
        }
        else {
            errorMsg = organisationValidate(name, value);

        }

        setErrors((prev) => ({
            ...prev,
            organisation: {
                ...prev.organisation,
                [name]: errorMsg,
            },
        }));
    };

    // Profile  File Handle
    const [profileFile, setProfileFile] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [previewLogo, setPreviewLogo] = useState(placeholder);

    const handleLogoChange = e => {
        const file = e.target.files[0];
        if (!file) return;
        setLogoFile(file);
        setPreviewLogo(URL.createObjectURL(file));
    };

    const [errors, setErrors] = useState({
        organisation: {},
        users: {}
    });

    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.organisation || {}).every((err) => !err) &&
            Object.values(errors.users || {}).every((err) => !err)
        );
    };

    const companyValid = (errors) => {
        return (
            Object.values(errors.organisation || {}).every((err) => !err)
        );
    }
    // console.log(organisation)
    // Submit and call the api function
    const handleCreate = async () => {

        // Organisation
        const formData = new FormData()

        formData.append('companyName', organisation.companyName)
        formData.append('companyWebsite', organisation.companyWebsite)
        formData.append('panNumber', organisation.panNumber)
        formData.append('industry', organisation.industry)
        formData.append('companyType', organisation.companyType)
        formData.append('companySize', organisation.companySize)
        formData.append('gstNumber', organisation.gstNumber)
        formData.append('addressLine1', organisation.headQuaters?.addressLine1)
        formData.append('addressLine2', organisation.headQuaters?.addressLine2)
        formData.append('city', organisation.headQuaters?.city)
        formData.append('country', organisation.headQuaters?.country)
        formData.append('state', organisation.headQuaters?.state)
        formData.append('zipCode', organisation.headQuaters?.zipCode)
        formData.append('description', organisation.description)

        if (logoFile) {
            const compressedFile = await compressImage(logoFile, { maxSizeMB: 0.7 });
            if (compressedFile) {
                formData.append("companyLogo", compressedFile);
                // formData.append("logoFile", compressedFile);
            }
        }

        formData.append('branches', JSON.stringify(organisation.branches));

        // Users
        const formData1 = new FormData()
        formData1.append('firstName', users.firstName)
        formData1.append('lastName', users.lastName)
        formData1.append('fullName', users.fullName)
        formData1.append('email', users.email)
        formData1.append('alternateEmail', users.alternateEmail)
        formData1.append('contact', users.contact)
        // formData1.append('reportingTeamLeadId', '')
        formData1.append('alternateContact', users.alternateContact)
        formData1.append('selectedRole', users.role)
        formData1.append('password', users.password)
        // formData.append('reportingTeamLeadId', users.)

        if (profileFile) {
            formData1.append('profile', profileFile)
        }
      
        await fetchCreate(BeURL, showAlert, formData, formData1)
    }

    if(!currentUser) return <FloatingLoading/>

    return (
        <main className="px-4 sm:px-6 md:px-12 lg:px-16 xl:px-24 pt-6 sm:pt-8">
            <section  >
                {/* Heading */}
                <div className="pb-3">
                    <h2 className="font-semibold text-2xl md:text-3xl text-primary-500">
                        Create Your Organization Account
                    </h2>
                    <p className="text-base mt-2">
                        Get started with SAN ATS by registering your company. Manage your hiring process, add your team, and connect with the right talent.
                    </p>
                </div>
                <div className=" flex flex-col  items-center">
                    <div className="bg-white px-5 rounded-xl py-1  w-[1200px]   mb-5">
                        {/* Fixed Header */}
                        <div className="sticky top-0 bg-white z-10 flex justify-start items-center py-2 border-b mb-4">
                            <GoOrganization className='text-2xl text-primary-500 mx-2' /><h3 className="text-lg font-semibold">Organisation Details</h3>

                        </div>
                        <div className="max-h-[600px] overflow-y-auto pr-2">
                            {/* ---------- Organisation ---------- */}

                            <div className="w-full mb-10 border  border-primary-50 px-3 shadow-sm rounded-xl py-2" >

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                                    <label className="inline">
                                        <img
                                            src={previewLogo}
                                            alt="Company Logo"
                                            className="w-24 h-24 object-cover rounded-full border inline"
                                        />
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleLogoChange}
                                            className="hidden "
                                        />
                                        <span className='text-sm px-2 text-primary-300 font-medium'>Click the logo to upload</span>
                                    </label>

                                    {[

                                        { label: "Company Website", name: "companyWebsite", value: organisation.companyWebsite, error: errors.organisation?.companyWebsite },
                                        { label: " Company Name", name: "companyName", value: organisation.companyName, error: errors.organisation?.companyName }
                                    ].map((field, idx) => (
                                        <InputRegister
                                            key={idx}
                                            label={field.label}
                                            value={field.value}
                                            name={field.name}
                                            mandatory
                                            required
                                            placeholder={field.label}
                                            type="text"
                                            className="min-w-full md:w-full"
                                            error={field.error}
                                            onChange={(e) =>
                                                handleOrganisation(e.target.name, e.target.value)
                                            }
                                        />
                                    ))}
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                                    {[

                                        { label: "PAN Number", name: "panNumber", value: organisation.panNumber, error: errors.organisation?.panNumber },
                                        { label: " Industry", name: "industry", value: organisation.industry, error: errors.organisation?.industry }
                                    ].map((field, idx) => (
                                        <InputRegister
                                            key={idx}
                                            label={field.label}
                                            value={field.value}
                                            name={field.name}
                                            mandatory
                                            required
                                            placeholder={field.label}
                                            type="text"
                                            className="min-w-full md:w-full"
                                            error={field.error}
                                            onChange={(e) =>
                                                handleOrganisation(e.target.name, e.target.value)
                                            }
                                        />
                                    ))}

                                    <div className='pt-1'>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            Company Type<sup className="text-red-500 text-sm">*</sup>
                                        </label>
                                        <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                            onChange={(e) =>
                                                handleOrganisation(e.target.name, e.target.value)
                                            }
                                            name='companyType'
                                            value={organisation.companyType}>

                                            <option className='text-gray-500' >Select Option</option>
                                            {
                                                types.map((t, i) =>
                                                (

                                                    <option value={t} key={i}>{t}</option>

                                                ))
                                            }
                                        </select>
                                        {errors.organisation?.companyType && < p class="text-sm text-red-500 mt-1 hidden">Error message</p>}
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                                    <div className='pt-1'>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            Company Size<sup className="text-red-500 text-sm">*</sup>
                                        </label>
                                        <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                            onChange={(e) =>
                                                handleOrganisation(e.target.name, e.target.value)
                                            }
                                            name='companySize'
                                            value={organisation.companySize}>
                                            <option className='' >Select Company Size</option>
                                            {
                                                size.map((s, i) =>
                                                (

                                                    <option value={s} key={i}>{s}</option>

                                                ))
                                            }
                                        </select>
                                        {errors.organisation?.companyType && < p class="text-sm text-red-500 mt-1 hidden">Error message</p>}
                                    </div>
                                    <InputRegister
                                        label="GST Number "
                                        value={organisation.gstNumber}
                                        name="gstNumber"
                                        onChange={(e) =>
                                            handleOrganisation(e.target.name, e.target.value)
                                        }
                                        mandatory
                                        required
                                        placeholder="GST Number"
                                        type="text"
                                        className="min-w-full md:w-full"
                                        error={errors.organisation?.gstNumber}
                                    />

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

                                </div>

                                <div className='border-[1px] border-gray-300 p-3 rounded-sm'>
                                    <p className="text-base font-semibold text-secondary-600">HeadQuaters  </p>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                                        {[
                                            {
                                                label: "Address Line1",
                                                name: "addressLine1",
                                                value: organisation.headQuaters.addressLine1,
                                                error: errors.organisation?.headQuaters?.addressLine1,
                                                mandatory: true,
                                                required: true
                                            },
                                            {
                                                label: "Address Line2",
                                                name: "addressLine2",
                                                value: organisation.headQuaters.addressLine2,
                                                error: errors.organisation?.headQuaters?.addressLine2
                                            },
                                            {
                                                label: "City",
                                                name: "city",
                                                value: organisation.headQuaters.city,
                                                error: errors.organisation?.headQuaters?.city,
                                                mandatory: true,
                                                required: true

                                            },
                                        ].map((field, idx) => (
                                            <InputRegister
                                                key={idx}
                                                label={field.label}
                                                value={field.value}
                                                name={field.name}
                                                mandatory={field.mandatory}
                                                required={field.required}
                                                placeholder={field.label}
                                                type="text"
                                                className="min-w-full md:w-full"
                                                error={field.error}
                                                onChange={(e) =>
                                                    handleOrganisation(e.target.name, e.target.value)
                                                }
                                            />
                                        ))}

                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                                        {[
                                            {
                                                label: "State",
                                                name: "state",
                                                value: organisation.headQuaters.state,
                                                error: errors.organisation?.headQuaters?.state,

                                            },
                                            {
                                                label: "Country",
                                                name: "country",
                                                value: organisation.headQuaters.country,
                                                error: errors.organisation?.headQuaters?.country,

                                            },
                                            {
                                                label: "Zip Code",
                                                name: "zipCode",
                                                value: organisation.headQuaters.zipCode,
                                                error: errors.organisation?.headQuaters?.zipCode,

                                            }
                                        ].map((field, idx) => (
                                            <InputRegister
                                                key={idx}
                                                label={field.label}
                                                value={field.value}
                                                name={field.name}
                                                mandatory
                                                required
                                                placeholder={field.label}
                                                type="text"
                                                className="min-w-full md:w-full"
                                                error={field.error}
                                                onChange={(e) =>
                                                    handleOrganisation(e.target.name, e.target.value)
                                                }
                                            />
                                        ))}

                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

                                        {[

                                        ].map((field, idx) => (
                                            <InputRegister
                                                key={idx}
                                                label={field.label}
                                                value={field.value}
                                                name={field.name}
                                                mandatory
                                                required
                                                placeholder={field.label}
                                                type="text"
                                                className="min-w-full md:w-full"
                                                error={field.error}
                                                onChange={(e) =>
                                                    handleOrganisation(e.target.name, e.target.value)
                                                }
                                            />
                                        ))}

                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                    {/* Branches Section */}
                                    <div className="col-span-1 md:col-span-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Branches <span className="text-red-500">*</span>
                                        </label>
                                        <div className='grid grid-cols-3 gap-4'>
                                            {organisation.branches.map((branch, idx) => (
                                                <div key={idx} className="flex items-center justify-center gap-2 mb-1">
                                                    <InputRegister
                                                        label={`Branch ${idx + 1}`}
                                                        value={branch}
                                                        name="branches"
                                                        onChange={(e) => handleOrganisation("branches", e.target.value, idx)}
                                                        placeholder="Branch Name"
                                                        type="text"
                                                        className=" flex-1 min-w-full md:w-full"
                                                        error={errors.organisation?.branches?.[idx]}

                                                    />

                                                    {organisation.branches.length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setOrganisation((prev) => {
                                                                    const updated = [...prev.branches];
                                                                    updated.splice(idx, 1);
                                                                    return { ...prev, branches: updated };
                                                                })
                                                            }
                                                            className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                                                        >
                                                            ✕
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setOrganisation((prev) => ({
                                                    ...prev,
                                                    branches: [...prev.branches, ""],
                                                }))
                                            }
                                            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                        >
                                            + Add Branch
                                        </button>
                                    </div>

                                    {/* Description Section */}
                                    <InputRegister
                                        label="Description"
                                        value={organisation.description}
                                        name="description"
                                        mandatory
                                        required
                                        placeholder="Description"
                                        type="text"
                                        className="min-w-[300px] md:w-full "
                                        error={errors.organisation?.description}
                                        onChange={(e) =>
                                            handleOrganisation(e.target.name, e.target.value)
                                        }
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </section>

            {/* Account create */}


            <section
                className={`${companyValid(errors)
                    ? ""
                    : "opacity-20 cursor-not-allowed pointer-events-none backdrop-blur-sm"
                    }`}
            >
                <AccountCreate errors={errors} setErrors={setErrors} users={users} setUsers={setUsers} profileFile={profileFile} currentUser={currentUser} setProfileFile={setProfileFile} />

            </section>

            <section>
                <div className='flex justify-end p-2'>
                    <button
                        type="submit"
                        disabled={!isFormValid(errors)}
                        className={`px-4 py-2 rounded ${isFormValid(errors)
                            ? "bg-secondary-200 text-white hover:bg-secondary-500"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                        onClick={handleCreate}>
                        Create Account
                    </button>

                </div>
            </section>
        </main >
    )
}
